import KpiCard from "@/components/base/KpiCard";
import DonutChart from "@/components/feature/DonutChart";
import SectionCard from "./SectionCard";
import { DualAxisLineChart, SliceLegend } from "./charts";
import { overviewKpis, dailySalesOrders, serviceDistribution, serviceSummary } from "@/mocks/salesReports";

const chartData = dailySalesOrders.map((d) => ({
  day: `يوم ${d.day}`,
  sales: d.sales,
  orders: d.orders,
}));

const total = serviceDistribution.reduce((s, d) => s + d.value, 0);

const segments = serviceDistribution.map((d) => ({
  label: d.name,
  pct: Math.round((d.value / total) * 100),
  color: d.color,
}));

export default function OverviewTab() {
  return (
    <div className="space-y-5">
      {/* KPIs */}
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-4">
        {overviewKpis.map((k) => (
          <KpiCard key={k.label} {...k} />
        ))}
      </div>

      {/* Line chart */}
      <SectionCard title="المبيعات والطلبات — آخر 30 يوم" subtitle="المبيعات على المحور الأيسر، وعدد الطلبات على المحور الأيمن">
        <DualAxisLineChart
          data={chartData}
          xKey="day"
          leftKey="sales"
          rightKey="orders"
          leftName="المبيعات (ر.س)"
          rightName="عدد الطلبات"
          height={320}
        />
      </SectionCard>

      {/* Donut + table */}
      <div className="grid grid-cols-1 gap-5 lg:grid-cols-5">
        <SectionCard title="توزيع الطلبات حسب الخدمة" className="lg:col-span-2">
          <div className="flex flex-col items-center">
            <DonutChart segments={segments} size={190} thickness={30} centerValue="247" centerLabel="طلب" />
            <SliceLegend items={segments} />
          </div>
        </SectionCard>

        <SectionCard title="ملخص الأداء حسب الخدمة" className="lg:col-span-3">
          <div className="overflow-x-auto">
            <table className="w-full min-w-[560px] text-sm">
              <thead>
                <tr className="text-xs font-semibold text-ghasla-text-secondary">
                  <th className="h-11 px-3 text-right">الخدمة</th>
                  <th className="h-11 px-3 text-right">الطلبات</th>
                  <th className="h-11 px-3 text-right">الإيرادات</th>
                  <th className="h-11 px-3 text-right">متوسط القيمة</th>
                  <th className="h-11 px-3 text-right">نسبة الإلغاء</th>
                </tr>
              </thead>
              <tbody>
                {serviceSummary.map((r) => (
                  <tr
                    key={r.service}
                    className={`border-t border-[#F4F8F8] ${r.total ? "bg-[#F0FDFD]" : "hover:bg-[#FAFEFE]"}`}
                  >
                    <td className={`h-12 px-3 ${r.total ? "font-bold text-ghasla-text-heading" : "font-medium text-ghasla-text-heading"}`}>
                      {r.service}
                    </td>
                    <td className={`h-12 px-3 ${r.total ? "font-bold text-ghasla-text-heading" : "text-ghasla-text-primary"}`}>
                      {r.orders}
                    </td>
                    <td className={`h-12 px-3 ${r.total ? "font-bold text-ghasla-text-heading" : "text-ghasla-text-primary"}`}>
                      {r.revenue.toLocaleString("en-US")} ر.س
                    </td>
                    <td className={`h-12 px-3 ${r.total ? "font-bold text-ghasla-text-heading" : "text-ghasla-text-primary"}`}>
                      {r.avg} ر.س
                    </td>
                    <td className={`h-12 px-3 ${r.total ? "font-bold text-ghasla-text-heading" : "text-[#E74C3C]"}`}>
                      {r.cancel}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </SectionCard>
      </div>
    </div>
  );
}